<template>
    <div class="landing-outer">
        <div></div>
        <div class="landing-inner">
            <div class="backdrop">
                <img src="@/assets/blue-green-background-capsule.webp" alt="DBG Home Background" style="width: 100%" />
            </div>
            <div class="scroll-container">
                <div class="login-button">
                    <DbgHealthLogo width="31.25rem" height="15.625rem" :fill="themeColors.colorWhite" />
                    <div @click="doLogin">Sign in to Hub</div>
                </div>
            </div>
        </div>
        <div class="dbg-divisions-logos">
            <ArrotexLogo width="10.3125rem" height="3.125rem" :fill="themeColors.colorMute" />
            <VidacorpLogo width="10.3125rem" height="3.125rem" :fill="themeColors.colorMute" />
            <IpaLogo width="10rem" height="5.3125rem" :fill="themeColors.colorMute" />
            <AxeLogo width="5.9375rem" height="3.125rem" :fill="themeColors.colorMute" />
        </div>
    </div>
</template>

<script setup lang="ts">
import DbgHealthLogo from '@/components/icons/DbgHealthLogo.vue'
import ArrotexLogo from '@/components/icons/ArrotexLogo.vue'
import VidacorpLogo from '@/components/icons/VidacorpLogo.vue'
import AxeLogo from '@/components/icons/AxeLogo.vue'
import IpaLogo from '@/components/icons/IpaLogo.vue'

import {useAuthStore, useThemeStore} from '@/stores'

const authStore = useAuthStore();
const themeStore = useThemeStore();
const { themeColors } = themeStore;

const doLogin = () => {
    authStore.login({targetUrl: "/"}); // will redirect
}

</script>

<style scoped>
.landing-outer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    padding: 1% 5%;
}

.landing-inner {
    position: relative;
}

.landing-inner .backdrop {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background-image: linear-gradient(to right, var(--color-arrotex-3), var(--color-vidacorp-3)); */
    border-radius: 156.25rem;
    position: relative;
    width: clamp(50rem, 87.5vw, 187.5rem);
    aspect-ratio: 50 / 23;
}

.landing-inner .scroll-container {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    top: 0;
    overflow-x: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.landing-inner .scroll-container::-webkit-scrollbar {
    display: none;
}

.landing-inner .scroll-container .login-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 31.25rem;
    min-height: 31.25rem;
    transition: transform 0.25s ease-in-out;
}

.landing-inner .scroll-container .login-button {

    &>div {
        font-size: 2rem;
        font-family: Inter;
        color: var(--color-white);
        bottom: 10%;
        transition: filter 0.25s ease-in;

        &:hover {
            cursor: pointer;
            filter: drop-shadow(0 0 0.9375rem rgba(255, 255, 255, 1));
        }
    }
}

.landing-inner .scroll-container .login-button.hide {
    transform: translateX(-300%);
}

.landing-inner:after {
    content: '';
    width: 30%;
    aspect-ratio: 1.25;
    background-color: var(--color-arrotex-3);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    border-radius: 50%;
    filter: blur(2.5rem);
    opacity: 0.75;
}

.landing-inner:before {
    content: '';
    width: 30%;
    aspect-ratio: 1;
    background-color: var(--color-vidacorp-3);
    position: absolute;
    top: 0;
    right: 0;
    z-index: -1;
    border-radius: 50%;
    filter: blur(2.5rem);
    opacity: 0.75;
}

.landing-inner .dbg-icon .login-button {
    font-size: 1.75rem;
    font-weight: 900;
    color: var(--color-white);
    text-transform: uppercase;
    position: absolute;
    bottom: 10%;

    &:hover {
        cursor: pointer;
    }
}

.dbg-divisions-logos {
    display: flex;
    align-items: center;
    height: 10%;
    justify-content: space-around;
    width: 60%;
}

</style>
